import { Theme } from "@mui/material";

export function getIconColor(active: boolean, theme: Theme) {
  return active ? theme.palette.primary.main : theme.palette.iconColor.main;
}
